<div class="menu-bar">
  <div>
      <a href="//www.iredo.info" target="_blank" class="menu-image">
        <img src="/img/logo.svg" alt="IREDO">
      </a>
    <a routerLink="/connections" routerLinkActive="active" class="menu-item menu-item-connections hoverable">
      <img class="menu-icon" src="/img/menu/connections.svg" title="{{'Jedoucí spoje' | translate}}" alt="{{'Jedoucí spoje' | translate}}" />
      {{ 'Spoje' | translate }}
    </a>
    <a routerLink="/stops" routerLinkActive="active" class="menu-item menu-item-stops hoverable">
      <img class="menu-icon" src="/img/menu/stops.svg" title="{{'Vyhledání zastávky' | translate}}" alt="{{'Vyhledání zastávky' | translate}}" />
      {{ 'Zastávky' | translate }}
    </a>
    <a routerLink="/contactPlaces" routerLinkActive="active" class="menu-item menu-item-contact hoverable">
      <img class="menu-icon" src="/img/menu/contact-places.svg" title="{{'Vyhledání kontaktního místa' | translate}}" alt="{{'Vyhledání kontaktního místa' | translate}}" />
      {{ 'Kontakt' | translate }}
    </a>

    <a href="https://www.idos.cz/iredo/spojeni/" target="blank" class="menu-item menu-item-idos hoverable">
      <img class="menu-icon" src="/img/menu/idos.svg" title="IDOS" alt="IDOS" />
      IDOS
    </a>

    <div class="menu-divider"></div>

    <div class="menu-item menu-item-language">
      <app-country-select />
    </div>
  </div>
</div>
